import { render, staticRenderFns } from "./SurveyManagementPreviewRatingSlider.vue?vue&type=template&id=8a5ca5ac&scoped=true&"
import script from "./SurveyManagementPreviewRatingSlider.vue?vue&type=script&lang=js&"
export * from "./SurveyManagementPreviewRatingSlider.vue?vue&type=script&lang=js&"
import style0 from "./SurveyManagementPreviewRatingSlider.vue?vue&type=style&index=0&id=8a5ca5ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5ca5ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a5ca5ac')) {
      api.createRecord('8a5ca5ac', component.options)
    } else {
      api.reload('8a5ca5ac', component.options)
    }
    module.hot.accept("./SurveyManagementPreviewRatingSlider.vue?vue&type=template&id=8a5ca5ac&scoped=true&", function () {
      api.rerender('8a5ca5ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-management/edit-question/question-preview/SurveyManagementPreviewRatingSlider.vue"
export default component.exports